import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IFAQ } from "../../models/BaseModel";
import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./bulkUpload";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { IBulkUploadProcess, IBulkUploadProcessDetail } from "./modal";
import { showDateTime } from "../../utilities/helper";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({
        data: [], count: 0, loading: false
    } as {
        data: IBulkUploadProcess[],
        count: number,
        loading: boolean
    });
    const [text, setText] = useState<string | null>(null);
    const [openDetails, setOpenDetails] = useState(false);
    const [details, setDetails] = useState({
        loading: false,
        data: [] as IBulkUploadProcessDetail[]
    });
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const loadTableDataRef = useRef<any>();

    const loadTableData = async (isSilent = false) => {
        if (!isSilent) {
            setTableData((prev) => ({ ...prev, loading: true, }));
        }
        const response = await Fetch("BulkUpload/GetBulkUploadProcess", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? "&text=" + text : ""}`, props.toast
        );
        if (response) {
            const data: { bulkUploadProcesses: IBulkUploadProcess[], count: number } = await response.json();
            setTableData({ data: data.bulkUploadProcesses, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    };

    loadTableDataRef.current = loadTableData;

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload]);

    useEffect(() => {
        const hasProcessing = tableData.data.some(row => row.isProcess === 0);
        if (hasProcessing) {
            const interval = setInterval(() => {
                loadTableDataRef.current?.(true);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [tableData.data]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };




    const loadProcessDetails = async (id: number) => {
        setOpenDetails(true);
        setDetails(prev => ({
            ...prev,
            loading: true
        }));
        const response = await Fetch(`BulkUpload/GetDetails/${id}`, "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setDetails({
                loading: false,
                data: data.bulkUploadProcessDetails
            });
        } else {
            setDetails({
                loading: false,
                data: []
            });
        }
    };



    const handleDownloadFailedRows = async (row: IBulkUploadProcess) => {
        const processId = row.id;
      

        if (!processId) return;

        try {
            const response = await fetch(
                `${baseUrl}Contact/DownloadFailedRows/${processId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Download failed");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `FailedLeadRows`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            props.toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Download Failed",
            });
        }
    };

    const actionBodyTemplate = (rowData: IBulkUploadProcess) => {
        const failedCount = rowData.failedCount ?? 0;

        return (
            <Button
                icon="pi pi-eye"
                label={`View Failed (${failedCount})`}
                className="p-button-rounded p-button-outlined p-button-danger p-button-sm"
                tooltip={
                    failedCount > 0
                        ? "View Failed Records"
                        : "No failed records available"
                }
                tooltipOptions={{ position: "top" }}
                disabled={failedCount === 0}
                onClick={() => loadProcessDetails(rowData.id)}
            />
        );
    };



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {/* <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} /> */}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Bulk Upload Process</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
            </div>
        </div>
    );



    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column header="S.No." body={(data, options) => options.rowIndex + 1} />

                <Column field="fileName" header="File Name" sortable />

                <Column field="uploadedBy" header="Uploaded By" sortable />

                <Column
                    field="uploadedTime"
                    header="Uploaded Time"
                    body={(row) =>
                        row.uploadedTime
                            ? showDateTime((row.uploadedTime))
                            : "-"
                    }
                />






                <Column
                    field="isProcess"
                    header="Status"
                    body={(row) => {
                        switch (row.isProcess) {
                            case 0:
                                return <Tag icon="pi pi-spin pi-spinner" value="Processing" severity="warning" />;
                            case 1:
                                return <Tag value="Completed" severity="success" />;
                            case 2:
                                return <Tag value="Failed" severity="danger" />;
                            default:
                            // return <Tag value="Unknown" severity="secondary" />;
                        }
                    }}
                />

                <Column
                    field="isProcessTime"
                    header="Completed Time"
                    body={(row) =>
                        row.isProcessTime
                            ? showDateTime((row.isProcessTime))
                            : "-"
                    }

                />

                <Column
                    header="Records"
                    body={(row: IBulkUploadProcess) => (
                        <span
                            className="record-summary"
                            data-pr-tooltip={`Total Records: ${row.totalRecords ?? 0}
Successful: ${row.successCount ?? 0}
Failed: ${row.failedCount ?? 0}`}
                            data-pr-position="top"
                            style={{ fontWeight: 600 }}
                        >
                            <span style={{ color: "#2563eb" }}>
                                {row.totalRecords ?? 0}
                            </span>

                            <span style={{ color: "#6b7280", margin: "0 4px" }}>/</span>

                            <span style={{ color: "#16a34a" }}>
                                {row.successCount ?? 0}
                            </span>

                            <span style={{ color: "#6b7280", margin: "0 4px" }}>/</span>

                            <span style={{ color: "#dc2626" }}>
                                {row.failedCount ?? 0}
                            </span>
                        </span>
                    )}
                />


                <Column
                    header="Download"
                    body={(row: IBulkUploadProcess) => (
                        <Button
                            icon="pi pi-download"
                            className="p-button-rounded p-button-text p-button-info"
                            tooltip="Download Failed Rows"
                            tooltipOptions={{ position: "top" }}
                            onClick={() => handleDownloadFailedRows(row)}
                            disabled={!row.failedCount || row.failedCount <= 0}
                        />
                    )}
                />
                <Column body={actionBodyTemplate} header="Action" />
            </DataTable>
            <ConfirmDialog />
            <Tooltip target=".record-summary" />
            <Dialog
                header="Bulk Upload Details"
                visible={openDetails}
                style={{ width: "90vw" }}
                maximizable
                onHide={() => setOpenDetails(false)}
            >

                <DataTable
                    value={details.data}
                    loading={details.loading}
                    stripedRows
                    scrollable
                    scrollHeight="60vh"
                    size="small"
                >
                    <Column
                        header="S.No."
                        body={(row, options) => options.rowIndex + 1}
                    />
                    <Column field="contact" header="Contact" />
                    <Column field="phone" header="Phone" />
                    <Column field="whatsapp" header="Whatsapp" />
                    <Column field="email" header="Email" />
                    <Column field="remark" header="Remark" />
                    <Column field="reason" header="Reason" />

                </DataTable>

            </Dialog>

        </>
    );
}
